import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Product } from '../../../dto/product';
import { UsersService } from '../../../services/crud/users.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '../../../dto/company';
import { CompanyService } from '../../services/company.service';
import { ProductService } from '../../services/product.service';

import { environment } from '../../../../environments/environment';


import {CardAcceptorListDto, FeeGroup, LimitGroup, PermsGroup} from "../../../dto/limitGroup";
import {ToastService} from 'angular-toastify';
import {UploadsAdminService} from "../../services/uploads-admin.service";
import {Upload} from "../../../dto/upload";
import {Country} from "../../../dto/country";
import {CountryService} from "../../../services";
import {SelectOption} from "../../searchable-multi-select/searchable-multi-select.component";

@Component( {
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: [ './product-edit.component.css' ]
} )
export class ProductEditComponent implements OnInit {
  product: Product;
  productId: number = null;
  companies: Company[];
  countries: Country[];

  products: Product[];

  productForm: FormGroup;

  limitGroups: LimitGroup[];
  permsGroups: PermsGroup[];
  feeGroups: FeeGroup[];

  whiteLists: CardAcceptorListDto[];
  blackLists: CardAcceptorListDto[];

  @ViewChild('fileInput', { static: false }) logoInput: ElementRef;
  isLoading = false;
  productUploads: Upload[];
  countriesOptions: SelectOption[] = [];

  constructor( private router: Router,
    private route: ActivatedRoute,
    private productService: ProductService,

    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private appUserService: UsersService,
    private location: Location, private toastService: ToastService,
    private uploadsAdminService: UploadsAdminService,
    private countryService: CountryService,
  ) { }



  ngOnInit() {
    const id = this.route.snapshot.paramMap.get( 'id' );

    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
      this.countriesOptions = this.countries.map(value => {
        return { label: value.name, value: value.isoCodeAlpha2 } as SelectOption;
      });
    });

    if( id != null ) {
      this.productId = parseInt( id );
    }

    this.uploadsAdminService.getMany(1, 500, 'uploadDate', 'desc', '', null, null, null, "Product").subscribe(dl => {
      this.productUploads = dl.data;
    });

    this.productService.getLimitGroups().subscribe(data => this.limitGroups = data);
    this.productService.getPermsGroups()
      .subscribe(data => this.permsGroups = data, err => this.permsGroups = []);
    this.productService.getFeeGroups().subscribe(data => this.feeGroups = data, err => this.feeGroups = []);
    this.productService.getBlackLists().subscribe(data => this.blackLists = data, err => this.blackLists = []);
    this.productService.getWhiteLists().subscribe(data => this.whiteLists = data, err => this.whiteLists = []);

    if ( id == null ) {
      this.initForm( {
        id: null,
        name: '',
        shortName: '',
        companyId: null,
        companyName: '',
        annualFee: null,
        annualFeeFromSecondYear: null,
        issuingFee: null,

        cardDesign: '',
        cardDesignVirtual: '',
        limitsGroup: '',
        permsGroup: '',
        isNoIdentCreationActive: false,
        cardDesignNoIdent: '',
        createTypeNoIdent: null,
        limitsGroupNoIdent: '',
        permsGroupNoIdent: '',
        convertToPhysicalAfterIdent: false,

        productRef: '',
        currCode: '',
        lang: '',
        loadValue: null,
        createType: null,
        createConvertToPhysical: false,
        imageId: null,

        restrictToCountriesAsList: [],
        feeGroup: '',
        carrierType: '',
        smsRequired: null,
        mailOrSms: null,
        action: null,
        delvMethod: null,
        logoId: null,
        logoUrl: null,
        active: true,
        cancellationPeriodDays: null,
        minimalContractPeriodMonths: null,
        productId: null,
        loadFeePercent: 0,
        loadFeeFixed: 0,
        loadFeeMinimum: 0,
        loadFeeMaximum: null,

        cardToCardFeePercent: 0,
        cardToCardFeeFixed: 0,
        cardToCardFeeMinimum: 0,
        cardToCardFeeMaximum: null,

        cardToCardReceiveFeePercent: 0,
        cardToCardReceiveFeeFixed: 0,
        cardToCardReceiveFeeMinimum: 0,
        cardToCardReceiveFeeMaximum: null,

        cardConversionFee: 0,


        cashbackActive: false,
        cashbackMaxPerMonth: 0,
        cashbackFactor: 0.0,
        cashbackMaxPerTransaction: 0,

        showPlayStoreIcon: false,
        showAppStoreIcon: false,
        playStoreLink: '',
        appStoreLink: '',
        appsList: '',

        sddDailyLoadLimit: 0,
        sddMonthlyLoadLimit: 0,
        sddYearlyLoadLimit: 0,
        sddDailyLoadFrequency: 0,
        sddMonthlyLoadFrequency: 0,
        sddYearlyLoadFrequency: 0,
        sddMaxBalance: 0,

        fddDailyLoadLimit: 0,
        fddMonthlyLoadLimit: 0,
        fddYearlyLoadLimit: 0,
        fddDailyLoadFrequency: 0,
        fddMonthlyLoadFrequency: 0,
        fddYearlyLoadFrequency: 0,
        fddMaxBalance: 0,

        eddDailyLoadLimit: 0,
        eddMonthlyLoadLimit: 0,
        eddYearlyLoadLimit: 0,
        eddDailyLoadFrequency: 0,
        eddMonthlyLoadFrequency: 0,
        eddYearlyLoadFrequency: 0,
        eddMaxBalance: 0,

        isDebtCollectionEnabled: false,
        isInstantLoadEnabled: false,
        skipAnnualFeeDeduction: false,
        skipAnnualFeeInvoiceGeneration: false,

        blackListCode: null,
        whiteListCode: null,

        displayDesign: null,
        virtualOnly: false,



      } as Product );
    } else {
      this.isLoading = true;
      this.productService.get( parseInt( id ) ).subscribe( result => {
        this.initForm( result );
        this.product = result;
        this.isLoading = false;
      } );
    }
    this.companyService.getAll().subscribe( x => {
      this.companies = x.data;
    } );

    this.productService.getAll().subscribe( x => {
      this.products = x.data;
    } );



  }



  initForm( product: Product ) {
    this.productForm = this.formBuilder.group( {
      active: product.active,
      id: product.id,
      productKey: product.productKey,
      name: product.name,
      internalName: product.internalName,
      shortName: product.shortName,
      companyId: product.companyId,
      companyName: product.companyName,
      annualFee: product.annualFee,
      annualFeeFromSecondYear: product.annualFeeFromSecondYear,
      restrictToCountriesAsList: [product.restrictToCountriesAsList],
      annualFeeUnder26: product.annualFeeUnder26,
      annualFeeFromSecondYearUnder26: product.annualFeeFromSecondYearUnder26,
      under26PromotionActive: product.under26PromotionActive,

      issuingFee: product.issuingFee,
      firstMonthsFree: product.firstMonthsFree,
      partnerPrice: product.partnerPrice,
      productRef: product.productRef,
      currCode: product.currCode,
      lang: product.lang,
      loadValue: product.loadValue,
      createType: product.createType,
      createConvertToPhysical: product.createConvertToPhysical,
      imageId: product.imageId,
      logoUrl: product.logoFileName ? environment.apiUrl + product.logoFileName : null,
      logoId: product.logoId,

      imgId: product.imgId,
      cleanCardImageId: product.cleanCardImageId,

      backgroundImageId: product.backgroundImageId,
      overlay1ImageId: product.overlay1ImageId,
      overlay2ImageId: product.overlay2ImageId,
      overlay3ImageId: product.overlay3ImageId,
      overlay4ImageId: product.overlay4ImageId,

      virtualOnlyBackgroundImageId: product.virtualOnlyBackgroundImageId,
      virtualOnlyOverlay1ImageId: product.virtualOnlyOverlay1ImageId,
      virtualOnlyOverlay2ImageId: product.virtualOnlyOverlay2ImageId,
      virtualOnlyOverlay3ImageId: product.virtualOnlyOverlay3ImageId,
      virtualOnlyOverlay4ImageId: product.virtualOnlyOverlay4ImageId,

      cardDesign: product.cardDesign,
      cardDesignVirtual: product.cardDesignVirtual,
      limitsGroup: product.limitsGroup,
      permsGroup: product.permsGroup,

      eddLimitGroup: product.eddLimitGroup,
      eddPermsGroup: product.eddPermsGroup,

      isNoIdentCreationActive: product.isNoIdentCreationActive,
      cardDesignNoIdent: product.cardDesignNoIdent,
      createTypeNoIdent: product.createTypeNoIdent,
      limitsGroupNoIdent: product.limitsGroupNoIdent,
      permsGroupNoIdent: product.permsGroupNoIdent,
      convertToPhysicalAfterIdent: product.convertToPhysicalAfterIdent,

      feeGroup: product.feeGroup,
      carrierType: product.carrierType,
      smsRequired: product.smsRequired,
      mailOrSms: product.mailOrSms,
      action: product.action,
      delvMethod: product.delvMethod,
      cancellationPeriodDays: product.cancellationPeriodDays,
      minimalContractPeriodMonths: product.minimalContractPeriodMonths,
      productId: product.productId,
      loadFeePercent: product.loadFeePercent,
      loadFeeFixed: product.loadFeeFixed,
      loadFeeMinimum: product.loadFeeMinimum,
      loadFeeMaximum: product.loadFeeMaximum,

      walletLoadFeePercent: product.walletLoadFeePercent,
      walletLoadFeeFixed: product.walletLoadFeeFixed,
      walletLoadFeeMinimum: product.walletLoadFeeMinimum,
      walletLoadFeeMaximum: product.walletLoadFeeMaximum,

      cardToCardFeePercent: product.cardToCardFeePercent,
      cardToCardFeeFixed: product.cardToCardFeeFixed,
      cardToCardFeeMinimum: product.cardToCardFeeMinimum,
      cardToCardFeeMaximum: product.cardToCardFeeMaximum,

      cardToCardReceiveFeePercent: product.cardToCardReceiveFeePercent,
      cardToCardReceiveFeeFixed: product.cardToCardReceiveFeeFixed,
      cardToCardReceiveFeeMinimum: product.cardToCardReceiveFeeMinimum,
      cardToCardReceiveFeeMaximum: product.cardToCardReceiveFeeMaximum,

      cardConversionFee: product.cardConversionFee,


      cashbackActive: product.cashbackActive,
      cashbackFactor: product.cashbackFactor,
      cashbackMaxPerMonth: product.cashbackMaxPerMonth,
      cashbackMaxPerTransaction: product.cashbackMaxPerTransaction,

      showPlayStoreIcon: product.showPlayStoreIcon,
      showAppStoreIcon: product.showAppStoreIcon,
      playStoreLink: product.playStoreLink,
      appStoreLink: product.appStoreLink,

      appsList: product.appsList,

      replacementProductId: product.replacementProductId,
      replacementProduct: product.replacementProduct,

      primaryProductId: product.primaryProductId,
      primaryProduct: product.primaryProduct,
      canOrderAsPrimary: product.canOrderAsPrimary,


      sddDailyLoadLimit: product.sddDailyLoadLimit,
      sddMonthlyLoadLimit: product.sddMonthlyLoadLimit,
      sddYearlyLoadLimit: product.sddYearlyLoadLimit,
      sddDailyLoadFrequency: product.sddDailyLoadFrequency,
      sddMonthlyLoadFrequency: product.sddMonthlyLoadFrequency,
      sddYearlyLoadFrequency: product.sddYearlyLoadFrequency,
      sddMaxBalance: product.sddMaxBalance,

      fddDailyLoadLimit: product.fddDailyLoadLimit,
      fddMonthlyLoadLimit: product.fddMonthlyLoadLimit,
      fddYearlyLoadLimit: product.fddYearlyLoadLimit,
      fddDailyLoadFrequency: product.fddDailyLoadFrequency,
      fddMonthlyLoadFrequency: product.fddMonthlyLoadFrequency,
      fddYearlyLoadFrequency: product.fddYearlyLoadFrequency,
      fddMaxBalance: product.fddMaxBalance,

      eddDailyLoadLimit: product.eddDailyLoadLimit,
      eddMonthlyLoadLimit: product.eddMonthlyLoadLimit,
      eddYearlyLoadLimit: product.eddYearlyLoadLimit,
      eddDailyLoadFrequency: product.eddDailyLoadFrequency,
      eddMonthlyLoadFrequency: product.eddMonthlyLoadFrequency,
      eddYearlyLoadFrequency: product.eddYearlyLoadFrequency,
      eddMaxBalance: product.eddMaxBalance,

      isDebtCollectionEnabled: product.isDebtCollectionEnabled,
      isInstantLoadEnabled: product.isInstantLoadEnabled,

      skipAnnualFeeDeduction: product.skipAnnualFeeDeduction,
      skipAnnualFeeInvoiceGeneration: product.skipAnnualFeeInvoiceGeneration,

      whiteListCode: product.whiteListCode,
      blackListCode: product.blackListCode,

      displayDesign: product.displayDesign,
      virtualOnly: product.virtualOnly,

      textDark: product.textDark,


    } );
  }

  returnBack() {
    this.location.back();
  }

  uploadImage( event ) {
    const file = event.target.files[ 0 ];
    const fileName = file != null ? file.name : null;

    this.productService.addImage( file ).subscribe( result => {
      this.productForm.patchValue( { logoId: result.id, logoUrl: result.fileUrl } );
    } );
  }

  onCountryChange() {
    // what?
  }

  resetLogoInput() {
    this.productForm.patchValue( { logoId: null, logoUrl: null } );
    this.logoInput.nativeElement.value = null;
  }

  onSubmit( form: FormGroup ) {
    if ( form.value.id ) {
      this.productService.update( form.value.id, form.value )
        .subscribe( res => this.returnBack(), err => {
          this.toastService.error(err.error.message || err.error || err.message);
        } );
    } else {
      this.productService.add( form.value )
        .subscribe( res => this.returnBack(), err => {
          this.toastService.error(err.error.message || err.error || err.message);
        } );
    }

  }


  protected readonly environment = environment;
}
